/**
 * Research Hub Page Data
 *
 * Metadata and topic listing for the /research hub page.
 */

import type { ResearchHubData } from './types'

export const researchHubData: ResearchHubData = {
  heading: 'Research & Evidence',
  introduction:
    'NCESP is committed to evidence-based advocacy. Our research summaries distill peer-reviewed studies into accessible overviews for parents, advocates, and policymakers. Explore the topics below to discover what the science says about shared parenting.',
  metaTitle: 'Research & Evidence | NCESP',
  metaDescription:
    'Evidence-based research summaries on shared parenting, overnights, and child outcomes from the National Council for Equal Shared Parenting.',
  topics: [
    {
      slug: 'overnights-and-parenting-plans',
      title: 'Overnights & Parenting Plans',
      description:
        'What does the research say about overnight stays for young children in shared parenting plans? A summary of peer-reviewed evidence on overnights, attachment, and child well-being.',
    },
  ],
}
